<template>
  <div class="container page account-setting-page set-sex-page">
    <van-nav-bar :title="$t('setting.sex_place')" class="nav-bar">
      <template #left>
        <button class="nav-back" type="button" aria-label="Back" @click="back()">
          <van-icon name="arrow-left" />
        </button>
      </template>
    </van-nav-bar>
    <main class="setting-content">
      <div class="setting-hero">
        <div class="setting-hero-icon"><van-icon name="friends-o" /></div>
        <div>
          <div class="setting-kicker">Profile preference</div>
          <h1>{{$t('setting.sex_place')}}</h1>
          <p>Select the profile information shown in your account.</p>
        </div>
      </div>
      <div class="sex settings-choice-card">
        <van-radio-group v-model="radio">
          <div class="item" :class="{'is-selected': String(radio) === '1'}" role="button" tabindex="0" :aria-pressed="String(radio) === '1'" @click="chooesSex(1)" @keyup.enter="chooesSex(1)">
              <span class="choice-icon"><van-icon name="contact" /></span>
              <van-radio name="1">{{$t("setting.man")}}</van-radio>
              <van-icon v-if="String(radio) === '1'" class="choice-check" name="success" />
          </div>
          <div class="item" :class="{'is-selected': String(radio) === '2'}" role="button" tabindex="0" :aria-pressed="String(radio) === '2'" @click="chooesSex(2)" @keyup.enter="chooesSex(2)">
            <span class="choice-icon"><van-icon name="flower-o" /></span>
            <van-radio name="2">{{$t("setting.female")}}</van-radio>
            <van-icon v-if="String(radio) === '2'" class="choice-check" name="success" />
          </div>
        </van-radio-group>
      </div>
      <p class="setting-note"><van-icon name="shield-o" /> Changes are saved immediately to your profile.</p>
    </main>
  </div>
</template>

<script>
export default {
  data() {
    return {
      radio:"",
      userInfo:{}
    };
  },
  methods: {
    back(){
      return window.history.back();
    },
    chooesSex(sex){
      this.$http({
        method: 'post',
        data:{sex:sex},
        url: 'user_set_sex'
      }).then(res=>{
        if(res.code === 200){
          this.getUserInfo();
          this.radio = String(sex);
          this.$toast(res.msg);
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    },
    getUserInfo(){
      console.log(window.localStorage.getItem("lang").toLowerCase())
      this.$http({
        method: 'get',
        url: 'user_info',
        headers: {
          lang: window.localStorage.getItem("lang").toLowerCase()
        }
      }).then(res=>{
        if(res.code === 200){
          this.userInfo = res.data;
          this.radio = String(res.data.sex);
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    }
  },
  created() {
    if(!localStorage.getItem('token')){
      this.$router.push({path:'/Login'})
    }else {
      this.getUserInfo();
    }
  }
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";
.container .sex .item{
  font-size: 0.37333rem;
  line-height: 50px;
  padding: 30px 0;
}
::v-deep .van-radio__label {
  line-height: 50px;
  margin-left: 30px;
}
::v-deep .van-radio__icon {
  font-size: 30px;
}
::v-deep .van-radio__icon--checked .van-icon {
  color: #fff;
  border-color: rgb(126, 86, 120);
  background-color: rgb(126, 86, 120);
}
.container .van-hairline--bottom::after {
  border-bottom-width: 3px;
}
.container .sex {
  font-size: .37333rem;
  color: #fff;
  padding: 0 40px;
}
.van-field__label {
  -webkit-box-flex: 0;
  -webkit-flex: none;
  flex: none;
  box-sizing: border-box;
  width: 6.2em;
  margin-right: 1.6vw;
  color: #fff;
  text-align: left;
  word-wrap: break-word;
}
.van-radio__label {
  color: #fff;
  line-height: 100%;
}
</style>
